<div style="align-content:center;width:99%; margin-right:0.5%; padding-top:0px;padding-left:600px; padding-bottom:0px">
  <span style="color: red;float:left; margin-right: 0.5%; margin-left: 0.5%;" *ngIf="isLoading">
    <mat-spinner [diameter]="40" style="float:left;"></mat-spinner>
    <strong> Report is Loading...</strong>
  </span>
</div>

<div class="report-frame" style="height:100%; width:99%;">
</div>
